<div class="bg-white rounded shadow p-2">
  <nz-skeleton-element
    style="width: 100% !important"
    class="h-96 w-full"
    nzType="image"
    [nzActive]="true"
  ></nz-skeleton-element>

</div>
